
import Swiper, {Navigation, Pagination} from 'swiper';

Swiper.use([Navigation, Pagination]);

export default {
  init() {
    if ($(window).scrollTop() >= 50){
      $('.header').addClass('active');
    }
    // JavaScript to be fired on all pages
    $(window).scroll(function () {
      var scroll = $(window).scrollTop();

      if (scroll >= 50) {
        $('.header').addClass('active');
      } else {
        $('.header').removeClass('active');
      }
    });
  },
  finalize() {
    new Swiper('.testimonials__swiper', {
      loop: false,
      navigation: {
        nextEl: '.testimonials__buttons__next', prevEl: '.testimonials__buttons__prev',
      },
      breakpoints: {
        991: {
          slidesPerView: 2,
        },
        1400: {
          slidesPerView: 3,
        }
      },
      paginationClickable: true,
      spaceBetween: 20,
    });

    // JavaScript to be fired on all pages, after page specific JS is fired
    //when scroll add active class for header
    $('.header').addClass('transition');
    //mobile menu/burger active logic
    $('.burger').on('click', () => {
      $('.header').addClass('active');
      $('.burger').toggleClass('active')
      $('.mobile').toggleClass('active')
    });

    $('.mobile__item').on('click', function () {
      $('.header').addClass('active');
      $('.burger').removeClass('active')
      $('.mobile').removeClass('active')
    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js